// import isNil from 'lodash/isNil'
// import populate from 'coact/populate'

export default next => async (ctx) => {
  const { method } = ctx
  if (method === 'GET') return next(ctx)
  const { values } = ctx

  const key = values.key
  const supplierName = values.supplierName

  // generateKey
  values.name = [key, supplierName].join('-')

  return next(ctx)
}



// WEBPACK FOOTER //
// ./src/views/middlewares/fillSupplierKey.js